export enum UploadIdDocumentsEnumeration {
  DNI = 'DNI',
  NIE = 'NIE',
  NIE_PASSPORT = 'NIE_PASSPORT',
}
